import { IDashboard } from './types';

export function getEmptyDashboard(): IDashboard {
	return {
		name: '',
		grid: [],
		id: '',
		isDefault: false,
		isEnabled: true
	};
}
